import { getTokenImageSize, TokenImage, TokenSize } from "app/components/common";
import { COPY } from "app/constants";
import { BsMetaUtil, LendingVaultExpanded } from "@bridgesplit/abf-react";
import { Row, Text, Icon, Image, IconWithBackground, Tooltip } from "@bridgesplit/ui";

export function VaultTitle({ vault }: { vault: LendingVaultExpanded | undefined }) {
    return (
        <Row spacing={1}>
            <TokenImageForVault vaultExpanded={vault} />
            <Row spacing={1}>
                <Text>{vault?.vaultMetadata?.name}</Text>
                <VaultTagIcon tags={vault?.vaultMetadata?.tags} />
            </Row>
        </Row>
    );
}

export function VaultTagIcon({ tags }: { tags: string[] | undefined }) {
    if (!tags) return null;
    if (tags.includes("genesis"))
        return (
            <Tooltip title={COPY.VAULT_TERM_FEATURED}>
                <IconWithBackground size={24} tagColor="body">
                    <Icon type="rocket" sx={{ fontSize: "16px" }} />
                </IconWithBackground>
            </Tooltip>
        );
    return null;
}

export function TokenImageForVault({
    vaultExpanded,
    size = "lg"
}: {
    vaultExpanded: LendingVaultExpanded | undefined;
    size?: TokenSize;
}) {
    if (vaultExpanded?.vaultMetadata?.isGenesisVault) {
        const tokenSize = getTokenImageSize(size);
        return (
            <Image
                skeletonVariant="circular"
                variant="circle"
                size={tokenSize + "px"}
                src={vaultExpanded?.vaultMetadata?.tokenImage ?? BsMetaUtil.getImage(vaultExpanded?.principalMetadata)}
            />
        );
    }
    return <TokenImage metadata={vaultExpanded?.principalMetadata} size={size} />;
}
